import React from 'react';

export function CardPriceComponent({price}) {
    if (price && price.shortLabel) {
        const {perNight, shortLabel} = price;

        return (
            <span className="CommonRatioCard__price" >
                <span className={'CommonRatioCard__price__amount'}>{shortLabel}</span> {perNight}
            </span>
        );
    }
    return null;
}

export default CardPriceComponent;
